












import { Component, PropSync, Vue } from "vue-property-decorator";
import { api } from "@/api";
import { commitSetProjectId } from "@/store/gitlab/mutations";
import { readGitLabInfo } from "@/store/gitlab/getters";
import { dispatchRaiseErrorTimeout } from "@/store/appState/actions";

@Component
export default class SetProject extends Vue {
  @PropSync("updateProject", { type: Number, required: true })
  updateCount!: number;
  private projects = [];
  private selectedProject = readGitLabInfo(this.$store).projectId;
  private loading = true;

  private async created() {
    try {
      this.projects = await api.getProjectsOfUser();
    } catch (e) {
      dispatchRaiseErrorTimeout(
        this.$store,
        new Error(`Unable to fetch projects:<br>${e}`)
      );
    }
    this.loading = false;
  }

  private save() {
    if (this.selectedProject >= 0) {
      commitSetProjectId(this.$store, this.selectedProject);
      this.updateCount++;
    }
  }
}
